export { default } from './SliderRangeItem'
